import { z } from "zod";
export const TemplateFieldType = z.enum(["text", "textarea", "date", "number", "select", "yesno"]);
export const TemplatePrefill = z.enum(["customer.name", "customer.phone", "customer.email", "customer.state", "customer.zip"]);
export const TemplateField = z.object({
    key: z.string().regex(/^[a-z][a-z0-9_]{0,39}$/),
    label: z.string().trim().min(1).max(120),
    type: TemplateFieldType,
    required: z.boolean(),
    help: z.string().max(300).optional(),
    officialFieldRef: z.string().max(200).optional(),
    options: z.array(z.string().trim().min(1).max(120)).max(20).optional(),
    prefill: TemplatePrefill.optional(),
    sensitiveEnterOnOfficialSite: z.boolean().optional(),
}).superRefine((f, ctx) => {
    if (f.type === "select" && (!f.options || f.options.length === 0))
        ctx.addIssue({ code: z.ZodIssueCode.custom, path: ["options"], message: "A select field needs options" });
    if (f.type !== "select" && f.options !== undefined)
        ctx.addIssue({ code: z.ZodIssueCode.custom, path: ["options"], message: "Only select fields take options" });
    if (f.sensitiveEnterOnOfficialSite) {
        if (f.required)
            ctx.addIssue({ code: z.ZodIssueCode.custom, path: ["required"], message: "A sensitive field cannot be required" });
        if (f.prefill !== undefined)
            ctx.addIssue({ code: z.ZodIssueCode.custom, path: ["prefill"], message: "A sensitive field cannot be prefilled" });
    }
});
export const TemplateInput = z.object({
    programSlug: z.string().min(1),
    stateCode: z.string().length(2).nullable(),
    title: z.string().trim().min(1).max(160),
    instructions: z.string().max(4000),
    fields: z.array(TemplateField).min(1).max(60),
    sourceUrl: z.string().url().optional(),
}).superRefine((t, ctx) => {
    const seen = new Set();
    t.fields.forEach((f, i) => {
        if (seen.has(f.key))
            ctx.addIssue({ code: z.ZodIssueCode.custom, path: ["fields", i, "key"], message: `Duplicate field key ${f.key}` });
        seen.add(f.key);
    });
});
/** How a customer proves the link is theirs: last 3 ZIP digits or last 4 phone digits. */
export const ShareCheckKind = z.enum(["zip3", "phone4"]);
export const CUSTOMER_WORKSHEET_HEADER = "Independent preparation worksheet by Ask For Helping Hand. This is not a government form. Submit your application only on the official website.";
//# sourceMappingURL=worksheets.js.map